import { computed, defineComponent, getCurrentInstance, nextTick, Ref, ref, watch } from '@vue/composition-api';
import { i18n_t } from '@/locales/i18n';
import { downloadFileContent, getDownloadPath } from '@/renderer/scripts/utils/download/downloadHelper';
import { getCustomDomainOrWebUrl } from '@/renderer/scripts/utils/CustomDomain/customDomain';
import { InviteUrlInfo } from '@/renderer/views/desktop/ManageConsole/UserManagement/innerUser/compositions/inviteMemberHandler';
import { IS_BROWSER } from '@/common/constant';

const QRCode = require('qrcode');
export default function inviteQrcodeHandler(inviteUrlInfo: InviteUrlInfo) {
  const qrcodeVisible = ref(false); // 展示二维码
  const inviteUrl = computed(() => {
    const { code, domains } = inviteUrlInfo;
    const domain = getCustomDomainOrWebUrl(domains);
    const url = `${domain}/web/invitation/${encodeURIComponent(code as string)}`;
    return url;
  });
  let timer: any = null;
  const methods = {
    // 绘制二维码
    drawQRCode() {
      const canvas = document.getElementById('invitation-qrcode');
      QRCode.toCanvas(
        canvas,
        inviteUrl.value,
        {
          width: 160,
          height: 160,
          margin: 5,
        },
        (error: any) => {
          if (error) logger.ui.error('绘制二维码失败');
        },
      );
    },
    // 展示二维码
    showQrcode() {
      if (inviteUrlInfo.expired) return;
      if (timer) clearTimeout(timer);
      qrcodeVisible.value = true;
    },
    hideQrcode() {
      timer = setTimeout(() => {
        qrcodeVisible.value = false;
      }, 300);
    },
    // 保存二维码到本地
    async downloadQrcode() {
      const canvas = document.getElementById('invitation-qrcode') as any;
      const imgContent = canvas.toDataURL(); // 图片base64
      // pc端获得下载路径 TODO 从选路径到本地下载可以抽离成公共下载
      if (!IS_BROWSER) {
        const downloadTarget = await getDownloadPath();
        if (!downloadTarget) return;
        const base64Data = imgContent.replace(/^data:image\/png;base64,/, '');
        const binaryData = new Buffer(base64Data, 'base64');
        downloadFileContent({
          downloadTarget,
          fileName: i18n_t('邀请企业成员二维码.png'),
          fileContent: binaryData,
        });
      } else {
        const a: HTMLAnchorElement = document.createElement('a');
        a.href = imgContent;
        a.download = i18n_t('邀请企业成员二维码.png');
        a.target = '_blank';
        a.click();
      }
    },
  };
  watch(
    () => qrcodeVisible.value,
    val => {
      if (val) {
        nextTick(() => {
          methods.drawQRCode();
        });
      }
    },
  );

  return {
    qrcodeVisible,
    inviteUrl,
    methods,
  };
}
